const missingData = (item) => {
    // console.log(item, 'missingData')
    // the item is an Object.entry, so an array of 2 values, the field name and field value
// if there is no value for the field of interest
return (item[1] === undefined || item[1].length < 1 )
}
    

export default missingData